import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../core';
import { Accession, AccessionReadModel } from './accession';
import { EQueryAccessionInfo, AccessionSubjectReadModel } from './e-query-accession-info';

export interface AccessionsSearcher {
    search(subProtocolId: number, searchTerm: string): Observable<Accession[]>;
}

@Injectable()
export class AccessionsStorage implements AccessionsSearcher {
    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) { }

    public search(subProtocolId: number, searchTerm: string): Observable<Accession[]> {
        return searchTerm
            ? this.http.get(`${this.settings.apiUrl}/accessions`, { params: { searchTerm, subProtocolId: subProtocolId !== null ? subProtocolId.toString() : null } })
                .pipe(map(projects => deserialize(projects, AccessionReadModel).accessions))
            : of([]);
    }
}
